import { Box, InputBase, List, useTheme,ToggleButton, ToggleButtonGroup } from "@mui/material"
import { useState } from "react";
import { useEffect } from "react";

import ShSwitch from "../../theme/inputs/ShSwitch";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import { useUpdateRelationInvoiceProductsMutation } from "../../../newapi/global/relation/relationSlice";
import { showToastMessageUpdateRequest, showToastMessageRequestError } from "../../../utils/toasts";
import { useGetInvoiceCategorySelectQuery, useGetProductFromCategoryAndInvoiceProductQuery } from "../../../newapi/financial/invoiceCategorySlice";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import { yupRequired } from "../../../utils/validation";
import { InputDropdown } from "../../theme/dropdowns/InputDropdown";
import { convertInputToFloat } from "../../../utils/helpers";

const MUpdateRelationInvoiceProduct = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [selected, setSelected] = useState(-1);
    const [updateRelationInvoiceProduct,{isLoading}] = useUpdateRelationInvoiceProductsMutation();

    const { data: invoiceCategories, invoiceCategoryIsLoading } = useGetInvoiceCategorySelectQuery();

    const select = (selected) => {
        setSelected(selected);
    }

    const [productInfo, setProductInfo] = useState({
        name: "",
        isActive: false,
        price: 0,
        isCustomPrice: false,
        id: 0
    });

    useEffect(() => {
        if (props.productInfo) {
            setProductInfo(props.productInfo);
        }
    }, [props.productInfo]);

    const [fieldErrors, setFieldErrors] = useState({});

    const handleClose = () => {
        // reset object
        setProductInfo({
            name: "",
            isActive: false,
            price: 0,
            isCustomPrice: false,
            id: 0
        });

        props.handleClose();
    }
        
    const SaveRelationInvoiceProduct = async () => {
        try {
            if (isLoading) return;

            console.log(productInfo);
            const updateBody = {
                relationId: props.relationId,
                products: [
                    {
                        invoiceProductId: productInfo.invoiceProduct.id,
                        isCustomPrice: productInfo.isCustomPrice,
                        price: productInfo.isCustomPrice ? convertInputToFloat(productInfo.price) : 0,
                        invoiceCategoryProductId: productInfo.invoiceCategoryProductId,
                        isActive: productInfo.isActive
                    }
                ]
            };

            const data = await updateRelationInvoiceProduct(updateBody).unwrap();
            showToastMessageUpdateRequest(t, data);
            handleClose();
        } catch (err) {
            showToastMessageRequestError(t("update_failed"), t, err);
        }
    };
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const [selectedCategoryUpdate, setSelectedCategoryUpdate] = useState(null);
    const { data: categoryProduct, isLoading: categoryProductIsLoading } = useGetProductFromCategoryAndInvoiceProductQuery(
        selectedCategoryUpdate ?? { categoryId: props.productInfo?.categoryProduct?.id ?? 0, invoiceProductId: props.productInfo?.invoiceProduct?.id ?? 0 },
        { skip: !selectedCategoryUpdate }
    ); 

    useEffect(() => {
        if (categoryProduct && selectedCategoryUpdate) {
            setProductInfo(prevProductInfo => ({
                ...prevProductInfo,
                invoiceCategoryProductId: categoryProduct.id,
                categoryProduct: {
                    ...prevProductInfo.categoryProduct,
                    price: categoryProduct.price,
                    id: categoryProduct.id,
                    invoiceCategoryId: selectedCategoryUpdate.categoryId
                }
            }));

            setSelectedCategoryUpdate(null);
        }
    }, [categoryProduct, selectedCategoryUpdate]);

    useEffect(() => {
        if (categoryProduct && !productInfo?.isCustomPrice) {
            setProductInfo(prevProductInfo => ({
                ...prevProductInfo,
                price: categoryProduct.price
            }));
        }
    }, [categoryProduct, productInfo?.isCustomPrice]);

    const handleChange = (key, value) => {
        if (key === 'invoiceCategoryId') {
            setSelectedCategoryUpdate({ 
                categoryId: value,
                invoiceProductId: productInfo?.invoiceProduct?.id ?? 0
            });
        } else {
            setProductInfo({
              ...productInfo,
              [key]: value
            });
            setFieldErrors({
                ...fieldErrors,
                [key]: ''
              });
          };
        }
      

    return(
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("edit_invoice_product")}</Subheading>
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text light>{t("name")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ShValidatedInput
                            disabled={true}
                            name="name"
                            value={productInfo?.name}
                            onChange={handleChange}
                            error={fieldErrors.name}
                        />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text light>{t("active")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ShSwitch 
                            checked={productInfo?.isActive} 
                            onChange={(event) => handleChange('isActive', event.target.checked)} 
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text light>{t("category")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                    <InputDropdown
                        name="name"
                        displayName="name"
                        selected={invoiceCategories ? invoiceCategories.findIndex(item => item.id === productInfo?.categoryProduct?.invoiceCategoryId) ?? -1 : -1}
                        options={invoiceCategories ?? []}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleChange('invoiceCategoryId', invoiceCategories[selected]?.id)}
                        closeOnSelection
                    />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text light>{t("custom_price")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                    <ShSwitch 
                        checked={productInfo?.isCustomPrice} 
                        onChange={(event) => handleChange('isCustomPrice', event.target.checked)} 
                        color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text light>{t("price")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ShValidatedInput
                            disabled={!productInfo?.isCustomPrice}
                            name="price"
                            value={productInfo?.isCustomPrice ? productInfo?.price : productInfo?.categoryProduct?.price}
                            onChange={handleChange}
                            error={fieldErrors.price}
                        />
                    </Box>
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => SaveRelationInvoiceProduct()}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MUpdateRelationInvoiceProduct;
